<template>
    <div>
        <form-label v-if="label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
        <input type="hidden" :id="id" :name="name" :disabled="!enabled" :value="fieldValue">
        <div class="uk-form-controls">
            <div class="rr-advanced-select">
                <div class="rr-advanced-select__placeholder" @click="toggleEditingAndAttachEvent">
                    <slot name="placeholder" v-if="!active"></slot>
                    <div class="rr-advanced-select__placeholder-item" v-else v-html="active.innerHTML"></div>
                    <div class="rr-advanced-select__placeholder-icon uk-position-right uk-flex uk-flex-middle">
                        <i class="fal fa-chevron-down"></i>
                    </div>
                </div>
                <div class="rr-advanced-select__list" v-show="editing">
                    <div class="rr-advanced-select__list-item" v-for="(item, key) in values" @click="setActive(key)" :ref="key">
                        <slot name="item" :item="item" :index="key"></slot>
                    </div>
                </div>
            </div>
        </div>
        <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
    </div>
</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
    props: {
      values: {
        type: [Array, Object],
        required: true,
      },
    },
    data() {
      return {
        editing: false,
        isMounted: false,
      };
    },
    computed: {
      active() {
        if (!this.isMounted || this.fieldValue === null || this.fieldValue === '' || !this.$refs[parseInt(this.fieldValue)]) {
          return null;
        }
        return this.$refs[parseInt(this.fieldValue)][0];
      },
    },
    mounted() {
      this.isMounted = true;
    },
    updated() {
      if (this.fieldValue && !this.active) {
        this.fieldValue = parseInt(this.fieldValue);
      }
    },
    methods: {
      toggleEditingAndAttachEvent(e) {
        e.stopPropagation();
        this.toggleEditing();
        if (this.editing) {
          document.body.addEventListener('click', this.toggleEditing);
        }
      },
      toggleEditing() {
        this.editing = !this.editing;
        document.body.removeEventListener('click', this.toggleEditing);
      },
      setActive(key) {
        this.fieldValue = key;

        this.triggerChangeAndValidate();
        this.$emit('change', key);
      }
    }
  }
</script>

<style lang="less">
    .rr-advanced-select {
        position: relative;
        cursor: pointer;

        &__placeholder {
            border: 1px solid #e5e5e5;
            padding: 3px 32px 3px 10px;

            > div {
                box-sizing: border-box;
            }

            &-icon svg {
                margin-left: 10px;
                margin-right: 10px;
            }
        }

        &__list {
            background-color: #ffffff;
            position: absolute;
            top: 0;
            width: 100%;
            border: 1px solid darken(#e5e5e5, 20%);
            z-index: 1;
            overflow: auto;
            max-height: 450px;

            & > * {
                padding: 3px 32px 3px 10px;

                &:hover {
                    background-color: #f8f8f8;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/FormAdvancedSelect.vue